import { Link } from 'react-router-dom'

export default function NotFoundPage() {
  return (
    <div className="min-h-[60vh] flex items-center justify-center">
      <div className="text-center">
        <h1 className="text-6xl font-bold text-gray-900 mb-4">404</h1>
        <p className="text-xl text-gray-600 mb-8">Page not found</p>
        <Link
          to="/"
          className="inline-block bg-brand-green text-white px-6 py-3 rounded-lg font-semibold hover:bg-brand-green-dark transition"
        >
          Go Home
        </Link>
      </div>
    </div>
  )
}
